var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"back",on:{"click":_vm.goBack}},[_c('span',{staticClass:"iconfont icon-fanhui2"})]),_c('div',{staticClass:"title"},[_vm._v("用户协议")]),_c('div',{staticClass:"back"})]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.agreementContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }